import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Button, Icon, Message, Modal,
} from 'semantic-ui-react';

import errorType from './types/error_type';

import { clearError, sendSetNewPasswordEmail } from '../modules/account';

class EmailNewSetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      submitted: false,
      notification: false,
    };
  }

  componentDidMount() {
    const { connectedClearError } = this.props;
    connectedClearError();
  }

  componentDidUpdate(prevProps) {
    const { error, requestOut } = this.props;
    if (prevProps.requestOut === true && requestOut === false) {
      this.setNotificationState(error);
    }
  }

  setNotificationState(error) {
    this.setState({
      error,
      notification: true,
    });
  }

  handleClick = (event) => {
    const { connectedSendSetNewPasswordEmail } = this.props;
    event.preventDefault();
    connectedSendSetNewPasswordEmail();
    this.setState({
      submitted: true,
    });
  }

  handleModalClose = () => {
    const { connectedClearError } = this.props;
    connectedClearError();
    this.setState({
      error: false,
      notification: false,
    });
  }

  // TODO: Render this as a message in the card instead of as a modal.
  renderSuccessModal = (email) => (
    <Modal
      closeOnEscape={false}
      closeOnDimmerClick={false}
      open
      onClose={this.handleModalClose}
    >
      <Modal.Header content="Sent a new verification email" />
      <Modal.Content>
        <p>
          We&apos;ve sent an email to
          {' '}
          <b>{email}</b>
          {' '}
          to verify your account.
        </p>
        <Message positive>
          <p>
            Please check your inbox, and possibly your spam folder.
          </p>
        </Message>
      </Modal.Content>
    </Modal>
  );

  renderErrorModal = () => {
    const { error } = this.props;
    return (
      <Modal header="Error" open onClose={this.handleModalClose}>
        { error.error
          ? error.error.error
          : 'An error has occured. Please try again at a later time.' }
      </Modal>
    );
  }

  render() {
    const { email, requestOut } = this.props;
    const { error, notification, submitted } = this.state;
    const success = !error && !requestOut && submitted;
    return (
      <div>
        <Button
          content={success ? <Icon name="check circle" size="large" className="re is-margin-none" /> : 'Send a new verification email'}
          disabled={success}
          loading={requestOut}
          onClick={this.handleClick}
          primary
        />
        { notification && success && this.renderSuccessModal(email) }
        { notification && error && this.renderErrorModal() }
      </div>
    );
  }
}

EmailNewSetPassword.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  error: errorType,
  requestOut: PropTypes.bool.isRequired,
  connectedSendSetNewPasswordEmail: PropTypes.func.isRequired,
};

EmailNewSetPassword.defaultProps = {
  error: undefined,
};

const mapStateToProps = (state) => ({
  email: state.session.email,
  error: state.account.error,
  requestOut: state.account.setNewPasswordEmailRequestOut,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedClearError: clearError,
  connectedSendSetNewPasswordEmail: sendSetNewPasswordEmail,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmailNewSetPassword);
